export enum HomeSectionViewMode {
  Default = 'Default',
  Text = 'Text',
}
